<template>
    <span class="c-search__property">
        <label v-if="label">
            {{label}}:
        </label>
        {{ formattedValues }}
        <slot v-if="!isLastGroup">{{ propertyGroupDelimiter }}</slot>
    </span>
</template>

<script>
import { formatValuesWithCondensedUnits } from 'shared/services/attributeValueConcatenatorService.js';

export default {
	name: 'auto-suggest-item-property',
    props: {
        values: {
            required: true,
            type: Array
        },
        delimiter: {
            required: true,
            type: String
        },
        label: {
            required: true,
            type: String,
        },
        propertyGroupDelimiter: {
            required: true,
            type: String,
        },
        isLastGroup: {
            required: true,
            type: Boolean,
        }
    },
    computed: {
        formattedValues() {
            return formatValuesWithCondensedUnits(this.values, this.delimiter);
        }
    }
}
</script>
